/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-16 18:16:45
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-04-14 17:33:12
 * @FilePath: /unifyxp-v2-store-portal/src/components/Antd/Button/Button.tsx
 */
import React from 'react';
import { Button } from 'antd';
import css from './css.less';
interface IProps {
  children?;
  type?;
  className?;
  style?;
  icon?;
  danger?;
  size?;
  ghost?: boolean;
  onClick?: (e: React.MouseEvent) => void;
  disabled?: boolean;
  loading?: boolean;
  block?: boolean;
  id?: string;
  title?;
}
const GlobalButton = (props: IProps) => {
  const {
    children,
    onClick,
    type,
    style,
    className,
    icon,
    danger,
    size,
    disabled,
    loading,
    block,
    ghost,
    id,
    ...rest
  } = props;
  return (
    <Button
      id={id}
      ghost={ghost}
      disabled={disabled}
      type={type}
      danger={danger}
      loading={loading}
      className={`${css.btn} ${className || ''}`}
      style={style}
      icon={icon}
      size={size || 'default'}
      onClick={onClick && onClick}
      block={block}
      {...rest}>
      {children}
    </Button>
  );
};

const ColorLinedButton = (props) => {
  const { className, children, ...rest } = props;
  return (
    <Button className={`${className} ${css.colorLinedButton}`} {...rest}>
      {children}
    </Button>
  );
};

const LinedButton = (props) => {
  const { className, children, ...rest } = props;
  return (
    <Button className={`${className} ${css.linedButton}`} {...rest}>
      {children}
    </Button>
  );
};
export { ColorLinedButton, LinedButton };
export default GlobalButton;
